module.exports = __webpack_public_path__ + "static/media/nu.a33108fd.svg";